export { DMS_MODULE } from '../constants';
export const NAME = 'DailyPerformance';
export const API_NAME = 'DailyPerformance';
export const CRUMB_LABEL_KEY = 'DailyPerformance';
export const ALL = 'All';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };

